/* eslint-disable no-unused-vars */
import React from 'react';
import style from './edit.module.scss';
import EditIcon from 'icons/edit';
import cx from 'classnames';

export default function Edit({
  onClick,
  className,
}: {
  className?: string;
  onClick: (e: React.MouseEvent) => void;
}) {
  return (
    <div className={cx(style.container, className)} onClick={onClick}>
      <EditIcon></EditIcon>
      <span>Редактировать</span>
    </div>
  );
}
